var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidIcons030Camera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-width:3px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_30_-_CAMERA",
    "data-name": "30 - CAMERA"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.17,38.93H80.06l-.87-2.16A10.74,10.74,0,0,0,70,30.53H49.81a10.74,10.74,0,0,0-9.21,6.24l-.87,2.16H24.62a6.74,6.74,0,0,0-6.72,6.72v37a6.73,6.73,0,0,0,6.72,6.72H95.17a6.73,6.73,0,0,0,6.72-6.72v-37A6.74,6.74,0,0,0,95.17,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.09,64.13a25.2,25.2,0,1,1-25.2-25.2A25.2,25.2,0,0,1,85.09,64.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidIcons030Camera);
export default __webpack_public_path__ + "static/media/hid-icons_030-CAMERA.1cf2a7a4b089ac5b41b4380923a6ef1f.svg";
export { ForwardRef as ReactComponent };